import React, { useEffect, useState } from 'react'
import { gameStatusInfoDisplayState, gameStatusInfoState } from '../../globalStates/general/gameStatusInfo';
import { useRecoilState } from 'recoil';
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { gameStatusState } from '../../globalStates/general/gameStatus';
import { useMedia } from 'use-media';

const InfoWindow = (props) => {
  // game status
  // 1: choice
  // 2: get the word or item
  // 3: use the word or item ? 4 : 1
  // 4: function for use word or use item → game complete ? end : 1
  const [gameStatusValue, setGameStatusValue] = useRecoilState(gameStatusState);
  // ユーザーに提示するためのゲームの状態
  const [gameStatusInfo, setGameStatusInfo] = useRecoilState(gameStatusInfoState);
  const [gameStatusInfoAreaDisplay, setGameStatusInfoAreaDisplay] = useRecoilState(gameStatusInfoDisplayState);
  const [windowStatus, setWindowStatus] = useState("close"); // →open
  const isPC = useMedia({ minWidth: '1000px' });

  useEffect(() => {
    if (gameStatusInfo) {
      setWindowStatus("open");
    }
  }, [gameStatusInfo]);

  useEffect(() => {
    if (windowStatus === "open") {
      setTimeout(() => {
        setWindowStatus("close");
      }, 3000);
    }
  }, [windowStatus]);



  const handleClickOk = () => {
    setGameStatusValue(1);
    setWindowStatus("close");
  }

  const [scrollY, setScrollY] = useState(0);
  document.addEventListener('scroll', (event) => {
    setScrollY(window.scrollY);
  });
  let gameStatusInfoArea;
  if (isPC) {
    gameStatusInfoArea = css`
    #infoArea {
      animation: ${windowStatus === "close" ? "slideOut" : "slideIn"} 0.5s ease-in-out forwards;
      position: absolute;
      top: 10px;
      right: 10px;
      width: 500px;
      height: 150px;
      border-radius: 10px;
      background-color: #55c47670;
      backdrop-filter: blur(10px);
      /* transform: translateX(100%);
      transform: translateY(50%); */
      @keyframes slideIn {
        0% {
            transform: translateX(100%);
          }
          100% {
            transform: translateX(0);
            transform: translateY(${scrollY}px);
          }
      }
      @keyframes slideOut {
        0% {
          transform: translateX(0%);
          transform: translateY(${scrollY}px);
        }
        80% {
          transform: translateX(110%);
          /* transform: translateY(${window.scrollY}px); */
        }
        100% {
          transform: translateX(110%);
          display: none;
        }
      }


      button {
        z-index: 9999;
        background: none;
        position: absolute;
        top: 10px;
        right: 10px;
        border: none;
        cursor: pointer;
      }
      .wordArea {
        font-family: 'Zen Kaku Gothic New';
        margin-top: 58px;
        text-align: center;
      }

    }

  `;
  } else {
    gameStatusInfoArea = css`
    #infoArea {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 5px;
      font-size: .5em;
      position: absolute;
      bottom: 44vh;
      right: 3vw;
      width: 220px;
      height: 15vh;
      border-radius: 10px;
      background-color: #55c47670;
      backdrop-filter: blur(10px);
      .wordArea {
        font-family: 'Zen Kaku Gothic New';
        text-align: center;
      }

    }

  `;
  }

  return (
    <>
      <div css={gameStatusInfoArea}>
        <div id='infoArea'>
          {isPC ? <button onClick={handleClickOk}>OK</button> : null}
          <div className='wordArea'>
            <p>{gameStatusInfo}</p>

          </div>
        </div>
      </div>
    </>
  )
}

export default InfoWindow
